<template>
  <div class="LKRoadmapsFeedIndex">
    <LKRoadmapsFeedFilters
      v-if="(isAdresat || isCurator || isCoordinator || isExpert) && !loading"
      v-model="filters"
      :years="years"
      :is-curator="isCurator"
      :is-coordinator="isCoordinator"
      :is-expert="isExpert"
    />

    <LKRoadmapsFeedTree
      v-if="isAdresat || isCurator || isCoordinator || isExpert"
      :event-id="eventId"
      :filters="filters"
      :filters-loading="loading"
      v-on="$listeners"
    />

    <div
      v-else
      class="text-md"
      v-text="'У Вас нет доступа к дорожным картам'"
    />
  </div>
</template>

<script>
import LKRoadmapsFeedFilters from './components/LKRoadmapsFeedFilters.vue'
import LKRoadmapsFeedTree from './components/LKRoadmapsFeedTree.vue'
import { RoadmapsFeedApi } from '@/api/resources'

export default {
  name: 'LKRoadmapsFeedIndex',
  inject: ['$eventId', 'isExpert', 'isAdresat', 'isCurator', 'isCoordinator'],
  components: {
    LKRoadmapsFeedFilters,
    LKRoadmapsFeedTree,
  },
  inheritAttrs: false,
  data: () => ({
    loading: true,
    years: [],
    filters: {},
  }),
  computed: {
    eventId() {
      return this.$eventId()
    },
  },
  async created() {
    this.loading = true
    try {
      await this.fetchYears()
      this.filters.year = this.years?.[0]
    } catch (err) {
      this.$notice.errors(err)
    }
    this.loading = false
  },
  methods: {
    async fetchYears() {
      const api = new RoadmapsFeedApi()
      const { data } = await api.getYears()
      this.years = data
    },
  },
}
</script>
